import appConfig from "./appConfig";
import { useInitSentry } from "./useInitSentry";
import CreateMicrositeLandingPage from "./pages/CreateMicrositeLandingPage";
import LandingPageWrapper from "./pages/LandingPageWrapper";
import AnalyticsTracker from "./components/AnalyticsTracker";

function App() {
  useInitSentry();

  if (window?.location) {
    const pathname = window.location.pathname.startsWith("/")
      ? window.location.pathname.slice(1)
      : window.location.pathname;
    const segments = pathname.split("/").filter(Boolean);
    // Support both /<company>/<pollId> and /microsite/<company>/<pollId>
    const companyName = segments[0] === "microsite" ? segments[1] : segments[0];
    const pollId = segments[0] === "microsite" ? segments[2] : segments[1];
    const urlParams = new URLSearchParams(window.location.search);
    const enableDemo = urlParams.get("enabledemo") === "true";

    // Set app configuration
    appConfig.companyName = decodeURIComponent(companyName || "");
    appConfig.pollId = pollId || "";
    appConfig.isCompanyCreated = companyName !== "admin" && Boolean(companyName) && Boolean(pollId);
    appConfig.enableDemo = Boolean(appConfig.enableDemo || enableDemo);

    // Set company name in localStorage before Redux store initializes
    if (appConfig.companyName) {
      localStorage.setItem("microsite-company-name", companyName);
    }

    // Base path route (microsite.bicycle.ai/)
    if (!appConfig.isCompanyCreated && companyName !== "admin" && !appConfig.isLocalDevServer) {
      window.open("https://www.bicycle.ai", "_self");
      return <></>;
    }

    // Set document title
    if (companyName) {
      window.document.title = companyName !== "admin" ? `Bicycle - ${appConfig.companyName}` : "Bicycle";
    }
  }

  // Handle non-company routes
  if (!appConfig.isCompanyCreated) {
    // For local development
    if (appConfig.isLocalDevServer) {
      return <CreateMicrositeLandingPage />;
    }

    // Redirect to the product UI for website creation when accessed via /admin
    window.open("https://app.ione.bicycle.io/create-website", "_self");
    return <></>;
  }

  // Render the wrapper that handles template fetching and routing
  return (
    <main>
      <AnalyticsTracker />
      <LandingPageWrapper />
    </main>
  );
}

export default App;
